/**
 * @namespace PIXI.loaders
 */
export { default as Loader } from './loader';
export { default as bitmapFontParser, parse as parseBitmapFontData } from './bitmapFontParser';
export { default as spritesheetParser } from './spritesheetParser';
export { default as textureParser } from './textureParser';
export { Resource } from 'resource-loader';
